
<template>
  <v-row>
    <v-col cols="12">
      <base-card>
        <v-card-title>Distribution Package "{{ distribPackage.name }}": Edit Metadata</v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <hot-table
                :data="packageChannels"
                :row-headers="true"
                :col-headers="true"
                :settings="hotSettings"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            @click="updatePack()"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </base-card>
    </v-col>
  </v-row>
</template>
<script>
  import { processDistributionPackage, processThirdPartyChannel } from '@/store/converters'
  import { HotTable } from '@handsontable/vue'
  import { registerAllModules } from 'handsontable/registry'
  import 'handsontable/dist/handsontable.full.css'

  registerAllModules()

  export default {
    metaInfo: {
      title: 'Edit Distribution Package',
    },
    components: {
      HotTable,
    },
    data: () => ({
      hotSettings: {
        width: '100%',
        colHeaders: ['Channel Name', 'VAST ID', 'Where to View', 'Per Deal Approval'],
        rowHeights: 35,
        manualColumnResize: true,
        height: 'auto',
        licenseKey: 'non-commercial-and-evaluation',
        columns: [
          {
            data: 'channelName',
            readOnly: true,
            width: 400,
          },
          {
            data: 'vastId',
            width: 100,
          },
        ],
      },
      distribPackage: {},
      packageChannels: [],
      channelMap: {},
      thirdPartyChannelMap: {},
    }),
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
    },
    created () {
      this.getPackageInfo(this.$route.params.distribution_id)
    },
    methods: {
      getPackageInfo (id) {
        this.$store.commit('setPageLoader')

        const args = {
          'id[eq]': id,
        }
        const packReq = this.$store.dispatch('distributionPackages', args)

        const channelArgs = {
          'suspended[eq]': 0,
        }
        const channelReq = this.$store.dispatch('channels', channelArgs)

        const packChannelReq = this.$store.dispatch('distributionPackageChannels', id)

        const thirdPartyChannelArgs = {}
        const thirdPartyChannelReq = this.$store.dispatch('thirdPartyChannels', thirdPartyChannelArgs)

        return Promise.all([packReq, channelReq, thirdPartyChannelReq, packChannelReq])
          .then((res) => {
            const packages = res[0] || []
            if (!packages.length) {
              this.$router.push({ name: 'Distributions' })
              return
            }
            this.distribPackage = processDistributionPackage(packages[0])

            const channels = res[1] || []
            for (let i = 0; i < channels.length; i += 1) {
              const ch = channels[i]
              this.channelMap[ch.id] = {
                id: ch.id,
                name: ch.name,
                external: false,
              }
            }

            const thirdPartyChannels = res[2] || []
            const thirdPartyChannelsProcessed = thirdPartyChannels.map((ch) => processThirdPartyChannel(ch))
            for (let i = 0; i < thirdPartyChannelsProcessed.length; i += 1) {
              const ch = thirdPartyChannelsProcessed[i]
              this.thirdPartyChannelMap[ch.id] = {
                id: '3rd' + ch.id,
                name: ch.name,
                external: true,
              }
            }

            const packChannels = res[3] || []
            this.processPackageChannels(packChannels)
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
            this.$router.push({ name: 'Distributions' })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      processPackageChannels (packChannels) {
        const processed = []

        for (let i = 0; i < packChannels.length; i += 1) {
          const d = packChannels[i]
          // eslint-disable-next-line no-prototype-builtins
          if (this.channelMap.hasOwnProperty(d.channel_id)) {
            const ch = this.channelMap[d.channel_id]
            processed.push({
              id: d.id,
              channelName: ch.name,
              vastId: d.vast_id || '',
              whereToView: d.where_to_view || '',
              perDealApproval: d.per_deal_approval || '',
            })
          }
          // eslint-disable-next-line no-prototype-builtins
          if (this.thirdPartyChannelMap.hasOwnProperty(d.third_party_channel_id)) {
            const ch = this.thirdPartyChannelMap[d.third_party_channel_id]
            processed.push({
              id: d.id,
              channelName: ch.name,
              vastId: d.vast_id || '',
              whereToView: d.where_to_view || '',
              perDealApproval: d.per_deal_approval || '',
            })
          }
        }
        this.packageChannels = processed
      },
      updatePack () {
        this.$store.commit('setPageLoader')

        const data = {
          id: this.distribPackage.id,
          channels: this.packageChannels,
        }

        this.$store.dispatch('distributionPackagesChannelMetaUpdate', data)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The metadata has been successfully updated',
              timeout: 6000,
              color: 'success',
            })
            this.$router.push({
              name: 'Distribution',
              params: {
                distribution_id: this.distribPackage.id,
              },
            })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.$store.commit('resolvePageLoader')
          })
      },
    },
  }
</script>

<style>
@media (min-width: 1200px) {
  .container {
    max-width: 1320px !important;
  }
}
</style>
